import { Box2 } from "three";
import { Box2Extensions } from "./Box2Extensions";
import { Line2 } from "./Line2";

export class Intersects2
{ 

  static Box2Line2( box:Box2, line2:Line2, linesOfBox:Line2[] = undefined )
  {
    if ( box.containsPoint( line2.start ) )
    {
      return true;
    }

    if ( box.containsPoint( line2.end ) )
    {
      return true;
    }

    linesOfBox = linesOfBox || Box2Extensions.getLines( box );

    for ( let i = 0; i < linesOfBox.length; i++ )
    {
      if ( linesOfBox[ i ].intersectsWith( line2 ) )
      {
        return true;
      }
    }

    return false;


  }
}